export default "__VITE_ASSET__1721d4f5__"